export const BOT_RESET_RESPONSE =
  "Great to hear! I'll reset our conversation so you can ask a new question.";
export const BOT_TYPE = "bot";
